// Programmatic local-SEO source of truth.
//
// Each entry becomes a page at /welding-electrodes-in/<slug>. To avoid thin
// "doorway" pages (which Google penalises), every city carries its OWN industrial
// context, so the generated copy is genuinely differentiated — not just a
// find-and-replace of the city name.
//
// To add a city: append an object here AND add its route to reactSnap.include in
// frontend/package.json (that list feeds prerendering and /sitemap.xml).

export const locations = [
  {
    slug: 'kota',
    city: 'Kota',
    state: 'Rajasthan',
    region: 'Hadoti',
    industries: ['thermal power plants', 'stone processing units', 'chemical & fertiliser plants'],
    blurb:
      'Kota is our home. Our factory at IPIA supplies welders across the Hadoti belt directly, with same-day pickup and technical support on the ground.',
  },
  {
    slug: 'jaipur',
    city: 'Jaipur',
    state: 'Rajasthan',
    region: 'Rajasthan',
    industries: ['general fabrication', 'auto components', 'building & infrastructure'],
    blurb:
      'From the fabrication clusters at Sitapura and Vishwakarma to infrastructure contractors across the Pink City, Jaipur workshops rely on a consistent, low-spatter rod.',
  },
  {
    slug: 'jodhpur',
    city: 'Jodhpur',
    state: 'Rajasthan',
    region: 'Marwar',
    industries: ['steel & structural fabrication', 'handicraft metalwork', 'guar processing plants'],
    blurb:
      'Jodhpur\u2019s steel furniture and structural workshops need electrodes that hold a clean bead on decorative and load-bearing work alike.',
  },
  {
    slug: 'udaipur',
    city: 'Udaipur',
    state: 'Rajasthan',
    region: 'Mewar',
    industries: ['zinc & lead smelting', 'mining equipment', 'marble processing'],
    blurb:
      'Serving Mewar\u2019s mining and smelting operations, where heavy-duty repair welding and deep penetration matter for plant uptime.',
  },
  {
    slug: 'bhilwara',
    city: 'Bhilwara',
    state: 'Rajasthan',
    region: 'Rajasthan',
    industries: ['textile machinery', 'cement plants', 'mineral processing'],
    blurb:
      'Bhilwara\u2019s textile mills and cement plants depend on quick, reliable maintenance welding to keep production lines running.',
  },
  {
    slug: 'ajmer',
    city: 'Ajmer',
    state: 'Rajasthan',
    region: 'Rajasthan',
    industries: ['railway workshops', 'general engineering', 'stone & marble'],
    blurb:
      'Home to major railway workshops, Ajmer fabricators need certified electrodes suited to rolling-stock repair and structural work.',
  },
  {
    slug: 'ahmedabad',
    city: 'Ahmedabad',
    state: 'Gujarat',
    region: 'Gujarat',
    industries: ['heavy fabrication', 'chemical plants', 'pharma machinery'],
    blurb:
      'Across Ahmedabad and the Sanand belt, plant fabricators and job shops choose IS 814-certified rods for pressure-work and structural fabrication.',
  },
  {
    slug: 'rajkot',
    city: 'Rajkot',
    state: 'Gujarat',
    region: 'Saurashtra',
    industries: ['casting & foundry', 'engineering clusters', 'agricultural machinery'],
    blurb:
      'Rajkot\u2019s dense engineering and casting cluster runs on high-volume welding \u2014 where a stable arc and low spatter save real time per shift.',
  },
  {
    slug: 'surat',
    city: 'Surat',
    state: 'Gujarat',
    region: 'South Gujarat',
    industries: ['shipbreaking & fabrication', 'textile machinery', 'diamond-tool workshops'],
    blurb:
      'From the Hazira industrial belt to textile-machinery workshops, Surat fabricators need rods that perform on both heavy plate and thin section.',
  },
  {
    slug: 'vadodara',
    city: 'Vadodara',
    state: 'Gujarat',
    region: 'Gujarat',
    industries: ['petrochemical plants', 'heavy engineering', 'power equipment'],
    blurb:
      'Vadodara\u2019s petrochemical and heavy-engineering plants demand certified, deep-penetration electrodes for maintenance and structural welding.',
  },
  {
    slug: 'indore',
    city: 'Indore',
    state: 'Madhya Pradesh',
    region: 'Malwa',
    industries: ['automotive machinery', 'pharma & food plants', 'general fabrication'],
    blurb:
      'Central India\u2019s commercial hub, Indore supplies job shops and OEM ancillaries that value a clean, quiet arc for repeatable results.',
  },
  {
    slug: 'pune',
    city: 'Pune',
    state: 'Maharashtra',
    region: 'Western Maharashtra',
    industries: ['automotive OEMs & ancillaries', 'heavy machinery', 'fabrication units'],
    blurb:
      'Pune\u2019s auto and machinery corridor from Pimpri-Chinchwad to Chakan runs high-throughput welding where consistency is everything.',
  },
  {
    slug: 'ludhiana',
    city: 'Ludhiana',
    state: 'Punjab',
    region: 'Malwa',
    industries: ['auto parts & cycles', 'hand tools', 'agricultural implements'],
    blurb:
      'The manufacturing heart of Punjab, Ludhiana\u2019s parts and implement makers need dependable rods for continuous production welding.',
  },
  {
    slug: 'faridabad',
    city: 'Faridabad',
    state: 'Haryana',
    region: 'NCR',
    industries: ['auto ancillaries', 'general engineering', 'sheet-metal fabrication'],
    blurb:
      'In the NCR industrial belt, Faridabad fabricators choose low-spatter E6013 rods for clean sheet-metal and structural work.',
  },
  {
    slug: 'delhi',
    city: 'Delhi',
    state: 'Delhi',
    region: 'NCR',
    industries: ['structural steel & metro infrastructure', 'sheet-metal fabrication', 'repair & maintenance workshops'],
    blurb:
      'From the fabrication lanes of Mayapuri and Okhla to metro and highway contractors, Delhi\u2019s welders need a rod that strikes easily and runs clean on every job.',
  },
  {
    slug: 'mumbai',
    city: 'Mumbai',
    state: 'Maharashtra',
    region: 'MMR',
    industries: ['ship repair & port works', 'high-rise construction', 'engineering workshops'],
    blurb:
      'Across Mumbai\u2019s ports, shipyards and the Bhiwandi\u2013Taloja industrial belt, coastal humidity makes well-packed, moisture-resistant electrodes essential.',
  },
  {
    slug: 'chennai',
    city: 'Chennai',
    state: 'Tamil Nadu',
    region: 'Tamil Nadu',
    industries: ['automotive manufacturing', 'boiler & pressure-vessel fabrication', 'heavy engineering'],
    blurb:
      'The Detroit of India \u2014 Chennai\u2019s auto plants in Sriperumbudur and Oragadam and its boiler fabricators run precision welding where bead quality matters.',
  },
  {
    slug: 'kolkata',
    city: 'Kolkata',
    state: 'West Bengal',
    region: 'Eastern India',
    industries: ['railway wagon & coach works', 'steel structures', 'jute & engineering mills'],
    blurb:
      'Eastern India\u2019s engineering hub, Kolkata\u2019s wagon builders, structural fabricators and mill maintenance teams depend on dependable all-position rods.',
  },
  {
    slug: "alwar",
    city: "Alwar",
    state: 'Rajasthan',
    region: "Mewat",
    industries: ["MIA & Matsya industrial area units", "auto & engineering components", "agro-processing plants"],
    blurb:
      "Alwar\u2019s Matsya Industrial Area and growing engineering units need a rod that runs smooth on daily fabrication and plant maintenance alike.",
  },
  {
    slug: "bhiwadi",
    city: "Bhiwadi",
    state: 'Rajasthan',
    region: "NCR Rajasthan",
    industries: ["auto-component manufacturing", "steel & sheet-metal fabrication", "industrial plant maintenance"],
    blurb:
      "Right on the NCR border, Bhiwadi\u2019s auto-component and fabrication plants run round-the-clock welding where a consistent, low-spatter arc keeps lines moving.",
  },
  {
    slug: "sri-ganganagar",
    city: "Sri Ganganagar",
    state: 'Rajasthan',
    region: "Northern Rajasthan",
    industries: ["agricultural implement making", "cotton ginning & mill maintenance", "trolley & body building"],
    blurb:
      "In Rajasthan\u2019s grain bowl, Sri Ganganagar workshops build and repair farm implements, trolleys and ginning machinery \u2014 work that demands tough, dependable joints.",
  },
  {
    slug: "nagaur",
    city: "Nagaur",
    state: 'Rajasthan',
    region: "Marwar",
    industries: ["agricultural equipment repair", "gate, grill & structural work", "mining & quarry maintenance"],
    blurb:
      "From Makrana\u2019s marble quarries to farm-equipment repair shops, Nagaur welders need electrodes that strike easily and hold up on heavy-duty jobs.",
  },
  {
    slug: "pali",
    city: "Pali",
    state: 'Rajasthan',
    region: "Marwar",
    industries: ["textile & dyeing unit maintenance", "cement plant fabrication", "general structural work"],
    blurb:
      "Pali\u2019s textile processing clusters and nearby cement plants rely on welders for constant machinery upkeep \u2014 a reliable all-position rod saves rework.",
  },
  {
    slug: "sikar",
    city: "Sikar",
    state: 'Rajasthan',
    region: "Shekhawati",
    industries: ["gate, grill & steel furniture", "agricultural trolleys", "building & construction"],
    blurb:
      "Across Shekhawati\u2019s fast-growing Sikar, fabricators turn out gates, grills, trolleys and building steel daily \u2014 jobs where a smooth bead and easy slag removal matter.",
  },
  {
    slug: "jhunjhunu",
    city: "Jhunjhunu",
    state: 'Rajasthan',
    region: "Shekhawati",
    industries: ["copper & mining equipment maintenance", "steel furniture & fabrication", "construction steelwork"],
    blurb:
      "From Khetri\u2019s copper belt to Jhunjhunu\u2019s fabrication workshops, welders need electrodes that perform on both maintenance and fresh structural work.",
  },
  {
    slug: "bharatpur",
    city: "Bharatpur",
    state: 'Rajasthan',
    region: "Braj",
    industries: ["agricultural machinery & threshers", "oil mill maintenance", "steel structures & sheds"],
    blurb:
      "Bharatpur\u2019s thresher makers, oil mills and structural fabricators run heavy everyday welding where arc stability and strength can\u2019t be compromised.",
  },
  {
    slug: "gangapur-city",
    city: "Gangapur City",
    state: 'Rajasthan',
    region: "Eastern Rajasthan",
    industries: ["agricultural implement repair", "gate & grill fabrication", "construction steelwork"],
    blurb:
      "Gangapur City\u2019s fabrication and repair workshops serve farms and builders across the region \u2014 a dependable E6013 rod keeps every job clean and strong.",
  },
  {
    slug: "jhalawar",
    city: "Jhalawar",
    state: 'Rajasthan',
    region: "Hadoti",
    industries: ["thermal power plant maintenance", "agro & orange-processing units", "structural fabrication"],
    blurb:
      "In the Hadoti belt next door to our Kota factory, Jhalawar\u2019s power-plant maintenance teams and fabricators get fast, direct supply and on-ground support.",
  },
  {
    slug: "baran",
    city: "Baran",
    state: 'Rajasthan',
    region: "Hadoti",
    industries: ["thermal power plant maintenance", "agricultural equipment", "rice & oil mill fabrication"],
    blurb:
      "Close to our Kota factory, Baran\u2019s power-plant contractors and agri-equipment workshops get quick dispatch of fresh, well-packed electrodes.",
  },
  {
    slug: "bundi",
    city: "Bundi",
    state: 'Rajasthan',
    region: "Hadoti",
    industries: ["stone & cement unit maintenance", "agricultural trolleys", "structural & gate fabrication"],
    blurb:
      "Just next to Kota, Bundi\u2019s stone units, cement works and fabrication shops are among the closest to our factory \u2014 same-day supply is the norm.",
  },
  {
    slug: "deoli",
    city: "Deoli",
    state: 'Rajasthan',
    region: "Tonk district",
    industries: ["agricultural equipment repair", "gate, grill & shed fabrication", "highway & construction work"],
    blurb:
      "On the Kota\u2013Jaipur highway, Deoli\u2019s repair workshops and fabricators handle everything from farm trolleys to sheds \u2014 and need a rod they can trust.",
  },
  {
    slug: "tonk",
    city: "Tonk",
    state: 'Rajasthan',
    region: "Central Rajasthan",
    industries: ["agricultural implements", "steel furniture & fabrication", "construction steelwork"],
    blurb:
      "Tonk\u2019s fabricators and repair workshops build and maintain farm and construction equipment daily \u2014 work where clean beads and easy strikes save time.",
  },
  {
    slug: "chaksu",
    city: "Chaksu",
    state: 'Rajasthan',
    region: "Jaipur district",
    industries: ["gate, grill & structural fabrication", "agricultural trolley building", "small engineering workshops"],
    blurb:
      "On the Jaipur\u2013Kota route, Chaksu\u2019s growing fabrication and trolley-building workshops get dependable supply straight from our Kota factory.",
  },
];

export const locationBySlug = (slug) =>
  locations.find((l) => l.slug === slug) || null;
